<div class="pt-3 pl-md-4 mb-6">

  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin">
        Admin
      </a></li>
      <li class="breadcrumb-item active" aria-current="page">
        Gift Center
      </li>
    </ol>
  </nav>

  <div class="row">
    <div class="col-md-5">
      <h2>Gift Center</h2>
    </div>
    <div class="col-md-7 text-right pb-2">
      <a *ngIf="orgConfig"
         href="{{ orgConfig.climber_app_base_url }}gift/" target="_blank"
         class="btn btn-outline-primary mr-2">
        Open Gift Center
      </a>

      <div class="dropdown d-inline">
        <button class="btn btn-primary dropdown-toggle" type="button"
                id="giftSettingsDropdownButton"
                data-toggle="dropdown" aria-expanded="false">
          Gift Center Settings
        </button>
        <div class="dropdown-menu dropdown-menu-right"
             aria-labelledby="giftSettingsDropdownButton">
          <a class="dropdown-item" routerLink="/gifting-config/home-page">
            Home Page
          </a>
          <a class="dropdown-item" routerLink="/gifting-config/discounts">
            Discounts
          </a>
          <a class="dropdown-item" routerLink="/gifting-config/gift-card-config">
            Gift Cards
          </a>
          <a class="dropdown-item" routerLink="/gifting-config/print-options">
            Print Options
          </a>
        </div>
      </div>
    </div>
  </div>

  <p>
    Use the Gift Center to determine which memberships, entry passes, and voucher packs may be gifted, and what policies apply to each giftable product. When gifting a product, the customer provides a recipient's email address, and Capitan delivers the gift on the selected date. The recipient will be prompted to create an account in Capitan if they do not have one already.
  </p>

  <h2 *ngIf="serverError !== null">
    Server Error: {{ serverError }}
  </h2>

  <ng-container *ngIf="serverError === null">

    <div class="alert my-3" role="alert"
       [class.alert-success]="history.state.feedback.status == 'success'"
       [class.alert-info]="history.state.feedback.status == 'info'"
       *ngIf="history && history.state && history.state.feedback">
      {{ history.state.feedback.text }}
    </div>

    <div class="mb-4">

      <div class="float-right">
        <a class="btn btn-success"
           routerLink="/gifting-config/membership-gift-configs/add">
          Add Membership Gift Config
        </a>
      </div>

      <h3>Membership Gifts <span *ngIf="loadingMembershipGiftingConfigs" class="text-secondary">- Loading...</span></h3>

      <div class="rounded-table-wrapper table-responsive-lg mb-2">
        <table class="table table-hover">

          <thead>
          <tr>
            <th>Membership Type(s)</th>
            <th>Max Future Date for Delivery</th>
            <th>Redemption Expiration</th>
          </tr>
          </thead>

          <tbody *ngIf="membershipGiftingConfigResultsPresent()">
          <tr *ngFor="let giftingConfig of membershipGiftingConfigList"
              style="cursor: pointer"
              routerLink="/gifting-config/membership-gift-configs/{{ giftingConfig.id }}">
            <td>
              <ng-container *ngFor="let membershipName of giftingConfig.assigned_membership_names">
                <span class="d-block">{{ membershipName }}</span>
              </ng-container>
              <ng-container *ngIf="giftingConfig.assigned_membership_names.length === 0">
                <span class="d-block text-muted">No memberships assigned</span>
              </ng-container>
            </td>
            <td>{{ giftingConfig.max_future_delivery_date_days }} days</td>
            <td>{{ giftingConfig.expiration_days }} days</td>
          </tr>
          </tbody>

          <tbody *ngIf="!membershipGiftingConfigResultsPresent()">
          <tr>
            <td colspan="99">
              {{ loadingMembershipGiftingConfigs ? 'Loading...' : 'No membership gifts configured' }}
            </td>
          </tr>
          </tbody>

        </table>
      </div>

      <a class="btn btn-success" routerLink="/gifting-config/membership-gift-configs/add">
        Add Membership Gift Config
      </a>

    </div>

    <div class="mb-4">

      <div class="float-right">
        <a class="btn btn-success"
           routerLink="/gifting-config/entry-pass-gift-configs/add">
          Add Entry Pass Gift Config
        </a>
      </div>

      <h3>Entry Pass Gifts <span *ngIf="loadingEntryPassGiftingConfigs" class="text-secondary">- Loading...</span></h3>

      <div class="rounded-table-wrapper table-responsive-lg mb-2">
        <table class="table table-hover">

          <thead>
          <tr>
            <th>Entry Pass Type(s)</th>
            <th>Max Future Date for Delivery</th>
            <th>Redemption Expiration</th>
          </tr>
          </thead>

          <tbody *ngIf="entryPassGiftingConfigResultsPresent()">
          <tr *ngFor="let giftingConfig of entryPassGiftingConfigList"
              style="cursor: pointer"
              routerLink="/gifting-config/entry-pass-gift-configs/{{ giftingConfig.id }}">
            <td>
              <ng-container *ngFor="let passName of giftingConfig.assigned_entry_pass_names">
                <span class="d-block">{{ passName }}</span>
              </ng-container>
              <ng-container *ngIf="giftingConfig.assigned_entry_pass_names.length === 0">
                <span class="d-block text-muted">No entry passes assigned</span>
              </ng-container>
            </td>
            <td>{{ giftingConfig.max_future_delivery_date_days }} days</td>
            <td>{{ giftingConfig.expiration_days }} days</td>
          </tr>
          </tbody>

          <tbody *ngIf="!entryPassGiftingConfigResultsPresent()">
          <tr>
            <td colspan="99">
              {{ loadingEntryPassGiftingConfigs ? 'Loading...' : 'No entry pass gifts configured' }}
            </td>
          </tr>
          </tbody>

        </table>
      </div>

      <a class="btn btn-success" routerLink="/gifting-config/entry-pass-gift-configs/add">
        Add Entry Pass Gift Config
      </a>

    </div>

    <div class="mb-4">

      <div class="float-right">
        <a class="btn btn-success"
           routerLink="/gifting-config/voucher-pack-gift-configs/add">
          Add Voucher Pack Gift Config
        </a>
      </div>

      <h3>Voucher Pack Gifts <span *ngIf="loadingVoucherPackGiftingConfigs" class="text-secondary">- Loading...</span></h3>

      <div class="rounded-table-wrapper table-responsive-lg mb-2">
        <table class="table table-hover">

          <thead>
          <tr>
            <th>Voucher Pack Type(s)</th>
            <th>Max Future Date for Delivery</th>
            <th>Redemption Expiration</th>
          </tr>
          </thead>

          <tbody *ngIf="voucherPackGiftingConfigResultsPresent()">
          <tr *ngFor="let giftingConfig of voucherPackGiftingConfigList"
              style="cursor: pointer"
              routerLink="/gifting-config/voucher-pack-gift-configs/{{ giftingConfig.id }}">
            <td>
              <ng-container *ngFor="let packName of giftingConfig.assigned_voucher_pack_names">
                <span class="d-block">{{ packName }}</span>
              </ng-container>
              <ng-container *ngIf="giftingConfig.assigned_voucher_pack_names.length === 0">
                <span class="d-block text-muted">No voucher packs assigned</span>
              </ng-container>
            </td>
            <td>{{ giftingConfig.max_future_delivery_date_days }} days</td>
            <td>{{ giftingConfig.expiration_days }} days</td>
          </tr>
          </tbody>

          <tbody *ngIf="!voucherPackGiftingConfigResultsPresent()">
          <tr>
            <td colspan="99">
              {{ loadingVoucherPackGiftingConfigs ? 'Loading...' : 'No voucher pack gifts configured' }}
            </td>
          </tr>
          </tbody>

        </table>
      </div>

      <a class="btn btn-success" routerLink="/gifting-config/voucher-pack-gift-configs/add">
        Add Voucher Pack Gift Config
      </a>

    </div>

  </ng-container>

</div>
